/* Sauce World USA theme · small, dependency-free */
(function () {
  // ---------- tracking: Shopify custom events (+ dataLayer for GA4/Meta later) ----------
  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  window.swuTrack = track;

  // product clicks (any product card)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-track-product]');
    if (a) track('swu_product_click', { product: a.dataset.trackProduct, list: a.dataset.trackList || document.body.className });
    var c = e.target.closest && e.target.closest('[data-track-concept]');
    if (c) track('swu_concept_click', { set: c.dataset.trackConcept });
  });

  // ---------- hero slideshow ----------
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-go]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = n;
      slides.forEach(function (s, k) { s.hidden = k !== n; });
      dots.forEach(function (d, k) { d.setAttribute('aria-pressed', k === n ? 'true' : 'false'); });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { clearInterval(timer); show(+d.dataset.go); });
    });
    var secs = parseInt(root.dataset.speed || '7', 10);
    if (!reduce && root.dataset.autoplay === 'true') {
      timer = setInterval(function () { show((i + 1) % slides.length); }, secs * 1000);
    }
  });

  // ---------- product variant picker ----------
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var addBtn = form.querySelector('[data-add]');
    var addLabel = addBtn ? addBtn.dataset.label : '';
    var mainImg = document.querySelector('[data-main-image]');
    var fmt = form.dataset.moneyFormat || '${{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }
    function selected() {
      var vals = [];
      form.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals[+fs.dataset.optionIndex] = c ? c.value : null;
      });
      return vals;
    }
    function update() {
      var vals = selected();
      var v = product.variants.find(function (x) {
        return x.options.every(function (o, k) { return vals[k] === o; });
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : 'Sold out';
      }
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image.src;
        mainImg.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('submit', function () {
      var vals = selected();
      track('swu_add_to_cart_intent', { product: product.handle, variant: idInput.value, options: vals.join(' / '), preorder: /Preorder/.test(vals.join(' ')) });
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('fieldset[data-option-index] input')) update();
    });
  });

  // ---------- product thumbnails ----------
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (!main) return;
      main.src = b.dataset.thumb;
      main.removeAttribute('srcset');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    });
  });

  // ---------- Trend Lab vote / waitlist ----------
  document.querySelectorAll('[data-vote]').forEach(function (root) {
    var set = root.dataset.set;
    track('swu_concept_view', { set: set });
    root.querySelectorAll('[data-piece]').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) track('swu_concept_click', { set: set, piece: b.dataset.piece });
      });
    });
    var form = root.querySelector('[data-vote-form]');
    if (!form) return;
    if (root.querySelector('[data-vote-ok]')) track('swu_waitlist_join', { set: set });
    form.addEventListener('submit', function () {
      var tags = ['trend-lab', 'waitlist-' + set];
      var color = form.querySelector('input[name="vote-color"]:checked');
      var size = form.querySelector('input[name="vote-size"]:checked');
      var intent = form.querySelector('input[name="vote-intent"]:checked');
      if (color) tags.push('vote-' + set + '-' + color.value);
      if (size) tags.push('size-' + size.value);
      if (intent) tags.push('intent-' + set);
      root.querySelectorAll('[data-piece][aria-pressed="true"]').forEach(function (b) { tags.push('pick-' + set + '-' + b.dataset.piece); });
      var optin = form.querySelector('[data-optin]:checked');
      if (optin) tags.push('opted-in');
      form.querySelector('[data-tags]').value = tags.join(', ');
      track('swu_vote_submit', { set: set, color: color ? color.value : '', size: size ? size.value : '', buy_intent: !!intent, email_optin: !!optin });
    });
  });
})();

/* ---------- v2.5: wishlist · compare · recently viewed · swatches · countdown · look · sticky buy · reveal ---------- */
(function () {
  var track = window.swuTrack || function () {};
  var fmt = document.body.dataset.moneyFormat || '${{amount}}';
  function money(c) { return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2).replace(/\.00$/, '')); }
  function get(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var cache = {};
  function fetchP(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function img(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cardHTML(p) {
    var cmp = p.compare_at_price > p.price ? '<span class="strike">' + money(p.compare_at_price) + '</span>' : '';
    return '<div class="cardw" data-card="' + esc(p.handle) + '"><a class="card" href="' + esc(p.url) + '" data-track-product="' + esc(p.handle) + '"><div class="ph">' +
      (p.featured_image ? '<img src="' + esc(img(p.featured_image, 700)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      '<div class="badges">' + (p.available ? '' : '<i>Sold out</i>') + '</div></div><div class="nm">' + esc(p.title) + '</div><div class="pr">' +
      (p.price_varies ? 'From ' : '') + money(p.price) + cmp + '</div></a>' +
      '<button type="button" class="heart" data-wish="' + esc(p.handle) + '" aria-pressed="false" aria-label="Save ' + esc(p.title) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.1 0 3.6 1.2 4.3 2.4.7-1.2 2.2-2.4 4.3-2.4 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z"/></svg></button></div>';
  }

  // wishlist
  var WK = 'swu_wish';
  function paintWish() {
    var w = get(WK);
    document.querySelectorAll('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', w.indexOf(b.dataset.wish) > -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-wish-count]').forEach(function (c) { c.textContent = w.length; c.hidden = !w.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var w = get(WK), h = b.dataset.wish, i = w.indexOf(h);
    if (i > -1) w.splice(i, 1); else { w.unshift(h); track('swu_wishlist_add', { product: h }); }
    set(WK, w.slice(0, 60)); paintWish();
    var list = document.querySelector('[data-product-list="wish"]');
    if (list && i > -1) { var c = list.querySelector('[data-card="' + CSS.escape(h) + '"]'); if (c) c.remove(); emptyCheck(list); }
  });
  function emptyCheck(list) { var e = list.parentNode.querySelector('[data-empty]'); if (e) e.hidden = list.children.length > 0; }

  // recently viewed
  var RK = 'swu_recent';
  var here = document.querySelector('[data-recent-add]');
  if (here) { var r = get(RK).filter(function (h) { return h !== here.dataset.recentAdd; }); r.unshift(here.dataset.recentAdd); set(RK, r.slice(0, 12)); }

  // render lists
  document.querySelectorAll('[data-product-list]').forEach(function (list) {
    var kind = list.dataset.productList, ex = list.dataset.exclude;
    var hs = get(kind === 'wish' ? WK : RK).filter(function (h) { return h !== ex; }).slice(0, +(list.dataset.limit || 60));
    if (!hs.length) { emptyCheck(list); return; }
    Promise.all(hs.map(fetchP)).then(function (ps) {
      list.innerHTML = ps.filter(Boolean).map(cardHTML).join('');
      emptyCheck(list); paintWish();
      var wrap = list.closest('[data-recent-wrap]'); if (wrap) wrap.hidden = !list.children.length;
    });
  });

  // compare
  var CK = 'swu_compare';
  var bar = document.querySelector('[data-compare-bar]');
  function paintCmp() {
    var c = get(CK);
    document.querySelectorAll('[data-compare-add]').forEach(function (x) { x.checked = c.indexOf(x.dataset.compareAdd) > -1; });
    if (bar) { bar.hidden = c.length < 1 || !!document.querySelector('[data-compare-table]'); bar.querySelector('[data-compare-count]').textContent = c.length + ' of 3 selected'; }
  }
  document.addEventListener('change', function (e) {
    var x = e.target.closest && e.target.closest('[data-compare-add]');
    if (!x) return;
    var c = get(CK), h = x.dataset.compareAdd, i = c.indexOf(h);
    if (x.checked && i < 0) { c.push(h); if (c.length > 3) c.shift(); }
    if (!x.checked && i > -1) c.splice(i, 1);
    set(CK, c); paintCmp();
  });
  if (bar) bar.querySelector('[data-compare-clear]').addEventListener('click', function () { set(CK, []); paintCmp(); });
  var table = document.querySelector('[data-compare-table]');
  if (table) {
    var hs = get(CK);
    var empty = table.parentNode.querySelector('[data-empty]');
    if (!hs.length) { empty.hidden = false; }
    else Promise.all(hs.map(fetchP)).then(function (ps) {
      ps = ps.filter(Boolean);
      function opt(p, n) { var o = (p.options || []).filter(function (x) { return x.name === n; })[0]; return o ? o.values.join(', ') : '—'; }
      var rows = [
        ['', function (p) { return '<a href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 500)) + '" alt="">' : '') + '<b>' + esc(p.title) + '</b></a>'; }],
        ['Price', function (p) { return (p.price_varies ? 'From ' : '') + money(p.price); }],
        ['Colors', function (p) { return esc(opt(p, 'Color')); }],
        ['Sizes', function (p) { return esc(opt(p, 'Size')); }],
        ['In stock', function (p) { return p.available ? 'Yes' : 'Sold out'; }],
        ['Details', function (p) { var d = document.createElement('div'); d.innerHTML = p.description || ''; return esc((d.textContent || '').slice(0, 220)); }],
        ['', function (p) { return '<a class="btn btn--neon" href="' + esc(p.url) + '">Shop it</a> <button type="button" class="btn btn--line" data-cmp-rm="' + esc(p.handle) + '">Remove</button>'; }]
      ];
      table.innerHTML = '<div class="cmpt__scroll"><table><tbody>' + rows.map(function (r) {
        return '<tr><th scope="row">' + r[0] + '</th>' + ps.map(function (p) { return '<td>' + r[1](p) + '</td>'; }).join('') + '</tr>';
      }).join('') + '</tbody></table></div>';
    });
    table.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cmp-rm]'); if (!b) return;
      set(CK, get(CK).filter(function (h) { return h !== b.dataset.cmpRm; })); location.reload();
    });
  }
  paintWish(); paintCmp();

  // swatch hover → swap card photo
  document.addEventListener('mouseover', function (e) {
    var d = e.target.closest && e.target.closest('.sw__dot[data-img]');
    if (!d) return;
    var im = d.closest('.cardw').querySelector('.ph img:not(.alt)');
    if (im) { im.removeAttribute('srcset'); im.src = d.dataset.img; }
  });

  // filters: sort changes submit instantly
  document.querySelectorAll('[data-sort]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  // countdown (only runs when a date is set; hides after it passes)
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var end = Date.parse(root.dataset.countdown);
    if (isNaN(end)) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { root.hidden = true; return false; }
      root.hidden = false;
      root.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
      root.querySelector('[data-h]').textContent = pad(Math.floor(s % 86400 / 3600));
      root.querySelector('[data-m]').textContent = pad(Math.floor(s % 3600 / 60));
      root.querySelector('[data-s]').textContent = pad(s % 60);
      return true;
    }
    if (tick()) var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000);
  });

  // shop the look dots
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-look-dot]');
    document.querySelectorAll('[data-look-dot][aria-expanded="true"]').forEach(function (x) { if (x !== b) x.setAttribute('aria-expanded', 'false'); });
    if (b) b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });

  // sticky add-to-bag (phones): shows once the main button scrolls away
  var sticky = document.querySelector('[data-stickybuy]');
  var mainAdd = document.querySelector('[data-product-form] [data-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }).observe(mainAdd);
    sticky.querySelector('[data-sticky-add]').addEventListener('click', function () { if (mainAdd.disabled) { mainAdd.scrollIntoView({ behavior: 'smooth', block: 'center' }); } else mainAdd.click(); });
    var sp = sticky.querySelector('[data-sticky-price]'), mp = document.querySelector('[data-price]');
    if (sp && mp) new MutationObserver(function () { sp.textContent = mp.textContent; }).observe(mp, { childList: true });
  }

  // scroll reveal (content is visible without JS; this only adds a lift-in)
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!rm && 'IntersectionObserver' in window) {
    var els = document.querySelectorAll('main section.sec, main .cwall, main .cardw');
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('rv'); io.observe(el); } });
  }
})();
